export const blueBarInit = {
    Nettiauto_mobile: {
        vehicleTypeFields: 'anyVehicleType=Y',
        makeFields: 'make=&model=',
        modelTypeFields: 'modelTypeName=',
        carTypeFields: 'anyCarType=Y&anyVanType=Y',
        fuelTypeFields: 'anyFuelType=Y',
        gearTypeFields: 'gearType=',
        yearModelFields: 'yearFrom=&yearTo=',
        mileageFields: 'kilometersFrom=&kilometersTo=',
        priceFields: 'priceFrom=&priceTo=',
        locationFields: 'regionTown=',
        engineSizeFields: 'engineSizeFrom=&engineSizeTo=',
        powerFields: 'powerFrom=&powerTo=&powerUnit=kw',
        curbWeightFields: 'curbWeightFrom=&curbWeightTo=',
        towWeightFields: 'towWeightFrom=&towWeightTo=',
        accelerationFields: 'accelerationFrom=&accelerationTo=',
        chargingTypeFields: '',
        chargingFields: 'chargingPowerFrom=&chargingPowerTo=',
        topSpeedFields: 'topSpeedFrom=&topSpeedTo=',
        driveTypeFields: 'anyDriveType=Y',
        consumptionFields: 'consumptionPlace=3&consumptionFrom=&consumptionTo=',
        electricConsumptionFields: 'electricConsumptionPlace=3&electricConsumptionFrom=&electricConsumptionTo=',
        co2EmissionFields: 'co2EmissionFrom=&co2EmissionTo=',
        seatsFields: 'seatsFrom=&seatsTo=',
        doorsFields: 'doorsFrom=&doorsTo=',
        maximumChargingPowerFields: 'maximumChargingPowerFrom=&maximumChargingPowerTo=',
        batteryGuranteeMonthFields: 'batteryGuaranteeMonthFrom=&batteryGuaranteeMonthTo=',
        batteryGuaranteeKmFields: 'batteryGuaranteeKmFrom=&batteryGuaranteeKmTo=',
        batteryCapacityFields: 'batteryCapacityFrom=&batteryCapacityTo=',
        electricRangeFields: 'electricRangeFrom=&electricRangeTo=',
        lastInspectionFields: 'lastInspectionMonth=&lastInspectionYear=',
        firstRegistrationFields: 'firstRegistrationMonth=&firstRegistrationYear=',
        torqueFields: 'torqueFrom=&torqueTo=',
        roadWorthyFields: 'roadWorthy=',
        steeringWheelFields: 'steeringWheelType=',
        accessoriesFields1: '',
        accessoriesFields2: '',
        accessoriesFields3: '',
        accessoriesFields4: '',
        colorFields: '',
        colorTypeFields: 'anyColorType=Y',
        searchTextFields: 'searchText=',
        postedByFields: 'postedBy%5B%5D=dealer&postedBy%5B%5D=seller',
        statusTypeFields: 'statusType=forsale',
        modifyAdFields: 'maxDaysSinceModification=',
        dealerShipFields: 'parentDealerList=',
    },
    Nettiauto: {
        basicInfoFields:
            'anyVehicleType=Y&anyFuelType=Y&make=&model=&modelTypeName=&gearType=&anyCarType=Y&anyVanType=Y&yearFrom=&yearTo=&kilometersFrom=&kilometersTo=&priceFrom=&priceTo=&regionTown=',
        technicalInfoFields:
            'anyDriveType=Y&consumptionPlace=3&consumptionFrom=&consumptionTo=&engineSizeFrom=&engineSizeTo=&co2EmissionFrom=&co2EmissionTo=&powerFrom=&powerTo=&powerUnit=kw&torqueFrom=&torqueTo=&towWeightFrom=&towWeightTo=&curbWeightFrom=&curbWeightTo=&accelerationFrom=&accelerationTo=&topSpeedFrom=&topSpeedTo=&seatsFrom=&seatsTo=&doorsFrom=&doorsTo=&steeringWheelType=&roadWorthy=&lastInspectionMonth=&lastInspectionYear=&firstRegistrationMonth=&firstRegistrationYear=',
        electricInfoFields:
            'batteryCapacityFrom=&batteryCapacityTo=&electricRangeFrom=&electricRangeTo=&electricConsumptionPlace=3&electricConsumptionFrom=&electricConsumptionTo=&chargingPowerFrom=&chargingPowerTo=&maximumChargingPowerFrom=&maximumChargingPowerTo=&batteryGuaranteeMonthFrom=&batteryGuaranteeMonthTo=&batteryGuaranteeKmFrom=&batteryGuaranteeKmTo=',
        accessoriesInfoFields: '',
        colorInfoFields: 'anyColorType=Y',
        otherInfoFields:
            'searchText=&maxDaysSinceModification=&postedBy%5B%5D=dealer&postedBy%5B%5D=seller&statusType=forsale&parentDealerList=',
    },
    Nettimoto: {
        basicInfoFields:
            'anyBikeType=Y&anyBodyType=Y&make=&modelType=&yearFrom=&yearTo=&priceFrom=&priceTo=&dayPriceFrom=&dayPriceTo=&regionTown=',
        technicalInfoFields:
            'engineSizeFrom=&engineSizeTo=&firstRegistrationMonth=&firstRegistrationYear=&kilometersFrom=&kilometersTo=&hoursFrom=&hoursTo=&fuelType=&gearType=&anyDriveType=Y&powerClass=&trackWidth=&anyCoolingType=Y&isRegistered=&roadWorthy=',
        accessoriesInfoFields: '',
        colorInfoFields: 'anyColorType=Y',
        otherInfoFields:
            'searchText=&maxDaysSinceModification=&postedBy%5B%5D=dealer&postedBy%5B%5D=seller&statusType=forsale',
    },
    Nettimoto_mobile: {
        bikeTypeFields: 'anyBikeType=Y',
        bodyTypeFields: 'anyBodyType=Y',
        makeFields: 'make=&modelType=',
        yearModelFields: 'yearFrom=&yearTo=',
        undrivenFields: '',
        priceFields: 'priceFrom=&priceTo=&dayPriceFrom=&dayPriceTo=',
        locationFields: 'regionTown=',
        engineSizeFields: 'engineSizeFrom=&engineSizeTo=',
        firstRegistrationFields: 'firstRegistrationMonth=&firstRegistrationYear=',
        kilometersFields: 'kilometersFrom=&kilometersTo=',
        hoursFields: 'hoursFrom=&hoursTo=',
        fuelTypeFields: 'fuelType=',
        gearTypeFields: 'gearType=',
        driveTypeFields: 'anyDriveType=Y',
        powerClassFields: 'powerClass=',
        trackWidthsFields: 'trackWidth=',
        coolingTypeFields: 'anyCoolingType=Y',
        registrationStatusFields: 'isRegistered=',
        roadWorthyFields: 'roadWorthy=',
        accessoriesFields: '',
        colorFields: '',
        colorTypeFields: 'anyColorType=Y',
        searchTextFields: 'searchText=',
        modifyAdFields: 'maxDaysSinceModification=',
        postedByFields: 'postedBy%5B%5D=dealer&postedBy%5B%5D=seller',
        statusTypeFields: 'statusType=forsale',
    },
    Nettivene: {
        basicInfoFields:
            'postedBy%5B%5D=dealer&postedBy%5B%5D=seller&statusType=forsale&make=&model=&yearFrom=&yearTo=&priceFrom=&priceTo=&regionTown=',
        technicalInfoFields:
            'boatLengthFrom=&boatLengthTo=&boatWidthFrom=&boatWidthTo=&boatWeightFrom=&boatWeightTo=&boatHeightFrom=&boatHeightTo=&boatDraftFrom=&boatDraftTo=&noOfBedsFrom=&noOfBedsTo=',
        engineInfoSelection:
            'boatWithoutEngine=N&engineMake=&enginePowerFrom=&enginePowerTo=&engineMfgYearFrom=&engineMfgYearTo=&engineHoursFrom=&engineHoursTo=',
        heatingInfoFields: '',
        sailInfoFields: '',
        accessoriesInfoFields: '',
        otherInfoSelection: 'maxDaysSinceModification=',
    },
    Nettivene_mobile: {
        postedByUserSelection: 'postedBy%5B%5D=dealer&postedBy%5B%5D=seller',
        adStatusSelection: 'statusType=forsale',
        boatTypeSelection: '',
        boatSubTypeSelection: '',
        makeFields: 'make=&model=',
        yearModelFields: 'yearFrom=&yearTo=',
        undrivenFields: '',
        priceFields: 'priceFrom=&priceTo=',
        locationFields: 'regionTown=',
        boatLengthFields: 'boatLengthFrom=&boatLengthTo=',
        boatWidthFields: 'boatWidthFrom=&boatWidthTo=',
        boatWeightFields: 'boatWeightFrom=&boatWeightTo=',
        heightFields: 'boatHeightFrom=&boatHeightTo=',
        draughtFields: 'boatDraftFrom=&boatDraftTo=',
        noOfBedsFields: 'noOfBedsFrom=&noOfBedsTo=',
        steeringSystemFields: '',
        bodyMaterialFields: '',
        boatEngineFields: 'boatWithoutEngine=N',
        engineTypeFields: '',
        engineRigField: '',
        engineMakeFields: 'engineMake=',
        enginePowerFields: 'enginePowerFrom=&enginePowerTo=',
        engineYearFields: 'engineMfgYearFrom=&engineMfgYearTo=',
        engineFuelTypeFields: '',
        engineStrokeFields: '',
        engineHoursFields: 'engineHoursFrom=&engineHoursTo=',
        coolingTypeFields: '',
        heatingMakeFields: '',
        heatingFuelTypeFields: '',
        sailMakeSelection: '',
        sailTypeFields: '',
        sailMaterialFields: '',
        accessoriesFields: '',
        lastUpdatedAdSelection: 'maxDaysSinceModification=',
    },
    Nettikaravaani: {
        basicInfoFields:
            'vehicleType=&anyBodyType=Y&make=&maxSpeed100=&anyBase=Y&yearFrom=&yearTo=&priceFrom=&priceTo=&dayPriceFrom=&dayPriceTo=&regionTown=',
        technicalInfoFields:
            'fuelType=&anyDriveType=Y&gearType=&doorsFrom=&doorsTo=&bedsFrom=&bedsTo=&seatsFrom=&seatsTo=&engineSizeFrom=&engineSizeTo=&powerFrom=&powerTo=&powerUnit=kw&lengthFrom=&lengthTo=&widthFrom=&widthTo=&weightCategory=&deadWeightFrom=&deadWeightTo=&weightFrom=&weightTo=&lastInspectionMonth=&lastInspectionYear=&firstRegistrationMonth=&firstRegistrationYear=',
        accessoriesInfoFields: '',
        adTypeSearchFields: 'adType=forsale&searchDate=&startDate=&endDate=',
        otherInfoFields:
            'searchText=&maxDaysSinceModification=&postedBy%5B%5D=dealer&postedBy%5B%5D=seller&statusType=forsale',
    },
    Nettikaravaani_mobile: {
        adTypeFields: 'adType=forsale',
        searchDateFields: 'searchDate=&startDate=&endDate=',
        vehicleTypeFields: 'vehicleType=',
        makeFields: 'make=',
        bodyTypeFields: 'anyBodyType=Y',
        baseFields: 'anyBase=Y',
        yearModelFields: 'yearFrom=&yearTo=',
        undrivenFields: '',
        priceFields: 'priceFrom=&priceTo=&dayPriceFrom=&dayPriceTo=',
        locationFields: 'regionTown=',
        kilometersFields: 'kilometersFrom=&kilometersTo=',
        lengthFields: 'lengthFrom=&lengthTo=',
        inspectedAfterDateFields: 'lastInspectionMonth=&lastInspectionYear=',
        engineSizeFields: 'engineSizeFrom=&engineSizeTo=',
        powerFields: 'powerFrom=&powerTo=&powerUnit=kw',
        widthFields: 'widthFrom=&widthTo=',
        firstRegistrationFields: 'firstRegistrationMonth=&firstRegistrationYear=',
        numberOfDoorsFields: 'doorsFrom=&doorsTo=',
        numberOfPersonsFields: 'seatsFrom=&seatsTo=',
        numberOfBedsFields: 'bedsFrom=&bedsTo=',
        weightCategoryFields: 'weightCategory=',
        maxSpeedFields: 'maxSpeed100=',
        fuelTypeFields: 'fuelType=',
        gearTypeFields: 'gearType=',
        driveTypeFields: 'anyDriveType=Y',
        bedTypeFields: 'bedType=',
        axisTypeFields: 'axisType=',
        emissionClassFields: 'emissionClass=',
        deadWeightFields: 'deadWeightFrom=&deadWeightTo=',
        grossWeightFields: 'weightFrom=&weightTo=',
        accessoriesFields1: '',
        accessoriesFields2: '',
        accessoriesFields3: '',
        colorFields: 'anyColor=Y',
        colorTypeFields: 'anyColorType=Y',
        searchTextFields: 'searchText=',
        postedByFields: 'postedBy%5B%5D=dealer&postedBy%5B%5D=seller',
        statusTypeFields: 'statusType=forsale',
        modifyAdFields: 'maxDaysSinceModification=',
    },
};
